import { render, staticRenderFns } from "./searchClass.vue?vue&type=template&id=4c137638&scoped=true"
import script from "./searchClass.vue?vue&type=script&lang=js"
export * from "./searchClass.vue?vue&type=script&lang=js"
import style0 from "./searchClass.vue?vue&type=style&index=0&id=4c137638&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c137638",
  null
  
)

export default component.exports